import { render, staticRenderFns } from "./FollowList.vue?vue&type=template&id=e1340194&scoped=true&"
import script from "./FollowList.vue?vue&type=script&lang=js&"
export * from "./FollowList.vue?vue&type=script&lang=js&"
import style0 from "./FollowList.vue?vue&type=style&index=0&id=e1340194&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1340194",
  null
  
)

export default component.exports